<template>
    <dir>
        ТУТ ДОЛЖЕН БЫТЬ АГРЕГАТОР
    </dir>
</template>
<script>
export default {
    name: "PageAgregator"
}
</script>